import { createApp, ref } from 'vue';
import {} from '@ts/common/datasets';
import { globalVueProperties } from '@ts/common/vue';
import Comparison from '@ts/components/analysis/Comparison.vue';
import '@ts/pages/page-defaults';
const dataAEl = document.querySelector('.hidden[data-analysis-a]');
const rawDataA = dataAEl?.getAttribute('data-analysis-a');
if (rawDataA === undefined || rawDataA === null || rawDataA === '') {
    throw new Error('No analysis data found in DOM element.');
}
let analysisDataA;
try {
    analysisDataA = JSON.parse(rawDataA);
}
catch (error) {
    throw new Error('Failed to parse analysis data from DOM element: ' + error);
}
const dataBEl = document.querySelector('.hidden[data-analysis-b]');
const rawDataB = dataBEl?.getAttribute('data-analysis-b');
if (rawDataB === undefined || rawDataB === null || rawDataB === '') {
    throw new Error('No analysis data found in DOM element.');
}
let analysisDataB;
try {
    analysisDataB = JSON.parse(rawDataB);
}
catch (error) {
    throw new Error('Failed to parse analysis data from DOM element: ' + error);
}
const app = createApp({
    setup() {
        const dataA = ref(analysisDataA);
        const dataB = ref(analysisDataB);
        return {
            dataA,
            dataB,
        };
    },
});
Object.assign(app.config.globalProperties, globalVueProperties());
app.component('Comparison', Comparison);
app.mount('#app');
